import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { IDNameDescriptionDictionary } from '../../models/Site';
import { SimulatorModel } from '../../models/SimulatorModel';
import { set } from 'date-fns';
import PoliciesTreatments from './_PoliciesTreatments';
import { TreatmentFilterModel } from '../../models/superbit-api-models';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import ClientPolicyDetailsCarOrRider from './_ClientPolicyDetailsCarOrRider';
import ClientPolicyDetailsHouse from './_ClientPolicyDetailsHouse';
import ClientPolicyDetailsRider from './_ClientPolicyDetailsRider';
import PoliciesDocuments from './_PoliciesDocuments';
import { GeneralDataModel } from '../../models/GeneralDataModel';
import ClientPolicyDetailsOther from './_ClientPolicyDetailsOther';

type Props = {
    data: any;
    config?: any;
    actions?: Function[];
    showAddTreatmentPopup?: (type: number) => void;
    displayFile?: (fileUrl: string) => void;
    fromRenewals?: boolean;
    customerData: any;
};
const ClientPolicyDetails = (props: Props) => {
    const customerCardModel = new CustomerCardModel();
    const [policy, setPolicy] = useState<any | null>(props.data);
    const [authorizedToDrive, setAuthorizedToDrive] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [eventTypes, setEventTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [servicesProvider, setServicesProvider] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [passedTypeOfInsurance, setPassedTypeOfInsurance] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [collectionMethodtype, setCollectionMethodType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [collectionRouteType, setCollectionRouteType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [apartmentPolicyType, setApartmentPolicyType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [apartmentCoverType, setApartmentCoverType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [coveragePercentageType, setCoveragePercentageType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [orderPlumberType, setOrderPlumberType] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());

    const [policyTypes, setPolicyTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());

    const [policyTreatmentsList, setPolicyTreatmentsList] = useState<any[]>([]);

    const getTreatments = async () => {
        // props.setLoading(true);
        let obj = {} as TreatmentFilterModel;
        obj.page = 1;
        if(policy.itemType === 'rider'){
            obj.riderId = policy.id;
        } else {
            obj.policyId = policy.id;
        }

        const treatmentsData = await customerCardModel.treatmentsFilter(obj);
        const treatments: any[] = [];
        if (treatmentsData.items && treatmentsData.items.length > 0) {
            treatmentsData.items.forEach((item: any) => {
                treatments.push(item);
            })
        }
        console.log('treatmentsData', treatmentsData, treatments);
        setPolicyTreatmentsList(treatments);
        // props.setLoading(false);
    }

    const policyData = useMemo(() => {
        const fetchData = async () => {
            const authorizedToDriveStorage = localStorage.getItem('authorizedToDrive');
            if (authorizedToDriveStorage) {
                const parsedAuthorizedToDrive = JSON.parse(authorizedToDriveStorage);
                if (parsedAuthorizedToDrive) {
                    console.log('storage-client-policy-details authorizedToDrive')
                    setAuthorizedToDrive(parsedAuthorizedToDrive);
                }
            } else {
                let authorizedToDrive = await new SimulatorModel().getAuthorizedToDriveItems();
                if (authorizedToDrive) {
                    localStorage.setItem('authorizedToDrive', JSON.stringify(authorizedToDrive));
                    setAuthorizedToDrive(authorizedToDrive);
                }
            }

            const eventTypesStorage = localStorage.getItem('eventTypes');
            if (eventTypesStorage) {
                const parsedEventTypes = JSON.parse(eventTypesStorage);
                if (parsedEventTypes ) {
                    console.log('storage-client-policy-details eventTypes')
                    setEventTypes(parsedEventTypes);
                }
            } else {
                let eventTypes = await new SimulatorModel().getEventTypes();
                if (eventTypes) {
                    localStorage.setItem('eventTypes', JSON.stringify(eventTypes));
                    setEventTypes(eventTypes);
                }
            }

            // setApartmentPolicyType(await new SimulatorModel().getApartmentPolicyTypes());
            const apartmentPolicyTypeStorage = localStorage.getItem('apartmentPolicyType');
            if (apartmentPolicyTypeStorage) {
                const parsedApartmentPolicyType = JSON.parse(apartmentPolicyTypeStorage);
                if (parsedApartmentPolicyType) {
                    console.log('storage-client-policy-details apartmentPolicyType')
                    setApartmentPolicyType(parsedApartmentPolicyType);
                }
            } else {
                let apartmentPolicyType = await new SimulatorModel().getApartmentPolicyTypes();
                if (apartmentPolicyType) {
                    localStorage.setItem('apartmentPolicyType', JSON.stringify(apartmentPolicyType));
                    setApartmentPolicyType(apartmentPolicyType);
                }
            }
            // setApartmentCoverType(await new SimulatorModel().getApartmentCoverTypes());
            const apartmentCoverTypeStorage = localStorage.getItem('apartmentCoverType');
            if (apartmentCoverTypeStorage) {
                const parsedApartmentCoverType = JSON.parse(apartmentCoverTypeStorage);
                if (parsedApartmentCoverType) {
                    setApartmentCoverType(parsedApartmentCoverType);
                }
            } else {
                let apartmentCoverType = await new SimulatorModel().getApartmentCoverTypes();
                if (apartmentCoverType) {
                    localStorage.setItem('apartmentCoverType', JSON.stringify(apartmentCoverType));
                    setApartmentCoverType(apartmentCoverType);
                }
            }
            // setCoveragePercentageType(await new SimulatorModel().getCoveragePercentageTypes());
            const coveragePercentageTypeStorage = localStorage.getItem('coveragePercentageType');
            if (coveragePercentageTypeStorage) {
                const parsedCoveragePercentageType = JSON.parse(coveragePercentageTypeStorage);
                if (parsedCoveragePercentageType) {
                    setCoveragePercentageType(parsedCoveragePercentageType);
                }
            } else {
                let coveragePercentageType = await new SimulatorModel().getCoveragePercentageTypes();
                if (coveragePercentageType) {
                    localStorage.setItem('coveragePercentageType', JSON.stringify(coveragePercentageType));
                    setCoveragePercentageType(coveragePercentageType);
                }
            }

            // setOrderPlumberType(await new SimulatorModel().getOrderPlumberTypes());
            const orderPlumberTypeStorage = localStorage.getItem('orderPlumberType');
            if (orderPlumberTypeStorage) {
                const parsedOrderPlumberType = JSON.parse(orderPlumberTypeStorage);
                if (parsedOrderPlumberType) {
                    setOrderPlumberType(parsedOrderPlumberType);
                }
            } else {
                let orderPlumberType = await new SimulatorModel().getOrderPlumberTypes();
                if (orderPlumberType) {
                    localStorage.setItem('orderPlumberType', JSON.stringify(orderPlumberType));
                    setOrderPlumberType(orderPlumberType);
                }
            }
            // setCollectionMethodType(await new SimulatorModel().getCollectionMethodTypes());
            const collectionMethodTypeStorage = localStorage.getItem('collectionMethodType');
            if (collectionMethodTypeStorage) {
                const parsedCollectionMethodType = JSON.parse(collectionMethodTypeStorage);
                if (parsedCollectionMethodType) {
                    setCollectionMethodType(parsedCollectionMethodType);
                }
            } else {
                let collectionMethodtype = await new SimulatorModel().getCollectionMethodTypes();
                if (collectionMethodtype) {
                    localStorage.setItem('collectionMethodType', JSON.stringify(collectionMethodtype));
                    setCollectionMethodType(collectionMethodtype);
                }
            }
            // setCollectionRouteType(await new SimulatorModel().getCollectionRouteTypes());
            const collectionRouteTypeStorage = localStorage.getItem('collectionRouteType');
            if (collectionRouteTypeStorage) {
                const parsedCollectionRouteType = JSON.parse(collectionRouteTypeStorage);
                if (parsedCollectionRouteType) {
                    setCollectionRouteType(parsedCollectionRouteType);
                }
            } else {
                let collectionRouteType = await new SimulatorModel().getCollectionRouteTypes();
                if (collectionRouteType) {
                    localStorage.setItem('collectionRouteType', JSON.stringify(collectionRouteType));
                    setCollectionRouteType(collectionRouteType);
                }
            }
            // setServicesProvider(await new SimulatorModel().getServicesProviderTypes());
            const servicesProviderStorage = localStorage.getItem('servicesProvider');
            if (servicesProviderStorage) {
                const parsedServicesProvider = JSON.parse(servicesProviderStorage);
                if (parsedServicesProvider) {
                    setServicesProvider(parsedServicesProvider);
                }
            } else {
                let servicesProvider = await new SimulatorModel().getServicesProviderTypes();
                if (servicesProvider) {
                    localStorage.setItem('servicesProvider', JSON.stringify(servicesProvider));
                    setServicesProvider(servicesProvider);
                }
            }
            // setPassedTypeOfInsurance(await new SimulatorModel().getPassedTypeOfInsurance());
            const passedTypeOfInsuranceStorage = localStorage.getItem('passedTypeOfInsurance');
            if (passedTypeOfInsuranceStorage) {
                const parsedPassedTypeOfInsurance = JSON.parse(passedTypeOfInsuranceStorage);
                if (parsedPassedTypeOfInsurance) {
                    setPassedTypeOfInsurance(parsedPassedTypeOfInsurance);
                }
            } else {
                let passedTypeOfInsurance = await new SimulatorModel().getPassedTypeOfInsurance();
                if (passedTypeOfInsurance) {
                    localStorage.setItem('passedTypeOfInsurance', JSON.stringify(passedTypeOfInsurance));
                    setPassedTypeOfInsurance(passedTypeOfInsurance);
                }
            }

            const policyTypesStorage = localStorage.getItem('policyTypes');
            if (policyTypesStorage) {
                const parsedPolicyTypes = JSON.parse(policyTypesStorage);
                if (parsedPolicyTypes) {
                    setPolicyTypes(parsedPolicyTypes);
                }
            } else {
                let policyTypes = await new GeneralDataModel().getAppDictionaryListExpanded();
                if (policyTypes) {
                    localStorage.setItem('policyTypes', JSON.stringify(policyTypes));
                    setPolicyTypes(policyTypes);
                }
            }

        }


        fetchData();
        getTreatments();

        const policy_data: Record<string, any> = {};

        return policy_data;
    }, []);


    const showPopUpAndAddTreatment = (type: number) => {
        if (props.showAddTreatmentPopup) {
            props.showAddTreatmentPopup(type);
        }
    }

    return (<>
        <div className='policy-item-details'>
            {(policy.policyType && policy.policyType.policyTypeId && (policy.policyType.policyTypeId == '1' || policy.policyType.policyTypeId == '9')) ?
                <ClientPolicyDetailsCarOrRider
                    policyItem={policy}
                    authorizedToDrive={authorizedToDrive}
                    eventTypes={eventTypes}
                    passedTypeOfInsurance={passedTypeOfInsurance}
                    collectionMethodtype={collectionMethodtype}
                    collectionRouteType={collectionRouteType}
                    policyTypes={policyTypes}
                    customerData={props.customerData}
                />
                : policy.itemType === 'rider' ?
                    <ClientPolicyDetailsRider
                        policyItem={policy}
                        authorizedToDrive={authorizedToDrive}
                        eventTypes={eventTypes}
                        servicesProvider={servicesProvider}
                        passedTypeOfInsurance={passedTypeOfInsurance}
                        collectionMethodtype={collectionMethodtype}
                        collectionRouteType={collectionRouteType}
                        customerData={props.customerData}
                    />
                    : policy.policyType && ( policy.policyType.policyTypeId == '2' || policy.policyType.policyTypeId == '3')?
                    <ClientPolicyDetailsHouse
                        policyItem={policy}
                        apartmentCoverType={apartmentCoverType}
                        coveragePercentageType={coveragePercentageType}
                        orderPlumberType={orderPlumberType}
                        collectionMethodtype={collectionMethodtype}
                        collectionRouteType={collectionRouteType}
                        eventTypes={eventTypes}
                        customerData={props.customerData}
                        policyTypes={policyTypes}
                    />
                    :<ClientPolicyDetailsOther
                        policyItem={policy}
                        apartmentCoverType={apartmentCoverType}
                        collectionMethodtype={collectionMethodtype}
                        collectionRouteType={collectionRouteType}
                        eventTypes={eventTypes}
                        customerData={props.customerData}
                        />
                       
            }



            {props.fromRenewals && props.fromRenewals == true ?
                (<></>) : (
                    <>
                        <PoliciesDocuments policyItem={policy} customerId={policy.customerId} displayFile={props.displayFile ? props.displayFile : () => { }} policyId={policy.id} showAddTreatmentPopup={showPopUpAndAddTreatment}/>
                        {(policy && (policy.itemType != undefined)) ? <PoliciesTreatments policyTreatmentsList={policyTreatmentsList} showAddTreatmentPopup={showPopUpAndAddTreatment} policyId={policy.id} itemType={policy.itemType} /> : ""}

                    </>
                )}
        </div>
    </>)
}

export default ClientPolicyDetails;